module.exports = __webpack_public_path__ + "static/Gza-Seminegra-0472c38feb6a63ba8c6aa1213d3a3e27.woff";